
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35321',
  depVersions: {
  "documents-public-ui": "static-1.35321",
  "atom": "static-1.5436",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2839",
  "client-types": "static-1.501",
  "cssUtils": "static-1.978",
  "customer-data-filters-ui": "static-1.41062",
  "customer-data-objects": "static-1.8048",
  "customer-data-property-utils": "static-1.8446",
  "documents-lib": "static-1.35326",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.375",
  "FormsCommonComponents": "static-1.86660",
  "FormUrlGenerator": "static-2.5074",
  "foundations-theming-specialty": "static-1.2549",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.112",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5945",
  "hs-test-utils": "static-1.8391",
  "hub-http": "static-1.6567",
  "hubspot-dlb": "static-2.1905",
  "HubStyle": "static-2.12153",
  "HubStyleTokens": "static-2.11846",
  "I18n": "static-7.1681",
  "icons": "static-2.695",
  "jasmine-immutable": "static-1.3367",
  "jasmine-runner": "static-1.6804",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7507",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3246",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5740",
  "quartz": "static-1.7520",
  "react": "static-7.199",
  "react-dlb": "static-1.90",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1.17079",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5592",
  "react-virtualized": "static-2.108",
  "reference-resolvers": "static-1.8536",
  "reference-resolvers-lite": "static-1.8458",
  "reporting-data": "static-1.68973",
  "reporting-reports": "static-1.68649",
  "reporting-snowflake": "static-1.57589",
  "reporting-testing-lib": "static-1.10906",
  "reporting-visualizations": "static-1.61047",
  "reselect": "static-3.13",
  "sales-content-partitioning": "static-1.9299",
  "sanitize": "static-1.4826",
  "sanitize-text": "static-1.8512",
  "SharedI18nStrings": "static-1.184",
  "SharedLegalStrings": "static-1.2089",
  "signup-constants": "static-1.19709",
  "signup-ui-url-generator": "static-2.8414",
  "StyleGuideUI": "static-3.509",
  "superstore": "static-1.5115",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5105",
  "ui-addon-form-validation": "static-1.11332",
  "ui-asset-management-lib": "static-1.11459",
  "ui-images": "static-2.1265",
  "UIComponents": "static-3.8792",
  "usage-tracker": "static-1.7667",
  "usage-tracker-container": "static-1.7657",
  "usage-tracker-core": "static-1.7517",
  "viral-links-lib": "static-1.7430",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10005",
  "foundations-components": "static-1.8569",
  "immutable": "static-2.87",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1298",
  "quartz-core": "static-1.6739",
  "quick-fetch": "static-1.4159",
  "raven": "static-3.5925",
  "redux": "static-4.80",
  "redux-thunk": "static-2.81",
  "rpc-client-utils": "static-1.5020",
  "ui-addon-i18n": "static-1.11502",
  "ui-addon-upgrades": "static-9.18447",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3797",
  "quartz-webpack": "static-1.3744",
  "foundations-assets": "static-1.5241",
  "foundations-theming": "static-1.4833",
  "hub-http-janus": "static-1.889",
  "hub-http-shared-msw-handlers": "static-1.10705",
  "hubspotter-http": "static-1.4895",
  "sassPrefix": "static-1.244",
  "conversations-skeleton-state": "static-1.7596",
  "crm-message-bus": "static-1.43867",
  "customer-data-filters-ui-msw-helpers": "static-1.23497",
  "customer-data-objects-ui-components": "static-1.13386",
  "customer-data-reference-ui-components": "static-1.13527",
  "customer-data-ui-utilities": "static-1.10186",
  "events-data-lib": "static-1.603",
  "framework-builder-read-service-client": "static-1.4257",
  "hs-resources": "static-1.548",
  "immer": "static-1.102",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4082",
  "multi-account-reference-resolvers": "static-1.1361",
  "onboarding-scopes": "static-1.6807",
  "onboarding-tours": "static-1.17209",
  "pulse": "static-1.986",
  "reporting-datasets-permissions-lib": "static-1.14555",
  "segments-client-types": "static-1.11710",
  "stylex": "static-1.42",
  "trellis-assets": "static-1.2771",
  "trellis-components": "static-1.2790",
  "trellis-theming": "static-1.1329",
  "ui-addon-teams": "static-1.21960",
  "quartz-auth": "static-1.1195",
  "ui-business-units-lib": "static-1.9446",
  "usage-tracker-session-replay": "static-1.5353",
  "ai-components-ui-library": "static-1.9818",
  "ContentUtils": "static-1.69226",
  "customer-data-properties": "static-1.52737",
  "forms-ai-lib": "static-1.4829",
  "forms-utils-lib": "static-1.13160",
  "foundations-components-test-utils": "static-1.6052",
  "react-dnd-compat": "static-1.4970",
  "react-tinymce": "static-1.56069",
  "tinymce-config": "static-2.55195",
  "ui-gdpr-components": "static-1.10644",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3818",
  "HeadJS": "static-2.805",
  "framer-motion": "static-1.80",
  "hs-test-utils-bend-plugin": "static-1.3502",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "hs-locale-management": "static-1.330",
  "ui-fonts": "static-1.1108",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4667",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1185",
  "web-vitals": "static-1.16",
  "batch-promise": "static-1.1899",
  "external-options-client-types": "static-1.4375",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7249",
  "quartz-i18n": "static-1.1195",
  "frontend-preferences-client": "static-1.8275",
  "graphql": "static-1.90",
  "persist-promise": "static-1.4056",
  "reporting-client-types": "static-1.2724",
  "apollo-stack-hubspot": "static-3.95",
  "growth-payments-core": "static-1.26282",
  "hubspot-apollo-client": "static-1.5230",
  "foundations-components-legacy": "static-1.1594",
  "quartz-routing": "static-1.950",
  "hs-story-utils": "static-1.9779",
  "react-flip-move": "static-1.79",
  "nested-table": "static-1.590",
  "seat-types-lib": "static-1.808",
  "timezone-utils": "static-2.5590",
  "react-create-root-preference": "static-1.80",
  "bend-plugin-foundations-components": "static-1.4838",
  "floating-ui": "static-1.64",
  "react-aria": "static-1.73",
  "tanstack-table": "static-1.62",
  "opentelemetry-fe-types": "static-1.134",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.509",
  "quartz-test": "static-1.1195",
  "quartz-tracking": "static-1.899",
  "bend-plugin-chirp-manifest": "static-1.430",
  "chirp-fetch": "static-1.2252",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6471",
  "ts-schema": "static-1.4328",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3316",
  "restore-request-side-panel-lib": "static-1.1769",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5005",
  "conditional-properties-service-client": "static-1.4052",
  "crm-pipelines-api-client-types": "static-1.4383",
  "event-emitter": "static-1.1312",
  "fdsr-migration-layer": "static-1.368",
  "multi-currency-client-types": "static-1.3943",
  "getting-started-shared-tasks": "static-1.19343",
  "growth-data-modal": "static-1.5965",
  "growth-onboarding-confetti": "static-1.3420",
  "growth-onboarding-next-action-utils": "static-1.2781",
  "navigation-components": "static-1.18925",
  "onboarding-tours-client": "static-1.5424",
  "onboarding-tours-utils": "static-1.1276",
  "ui-shepherd-react": "static-3.10626",
  "ui-shepherd-tracker": "static-1.8007",
  "ui-universal-auth": "static-1.9495",
  "user-context": "static-1.5469",
  "bend-plugin-pulse": "static-1.489",
  "fast-json-patch": "static-1.71",
  "crm-index-associations-lib": "static-1.6800",
  "stylex-utils": "static-1.149",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "hubspotter-http-shared-msw-handlers": "static-1.10703",
  "magpie-lib": "static-1.5795",
  "navigation-messaging": "static-1.8252",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23268",
  "copilot-toolkit": "static-1.11935",
  "cms-field-types": "static-1.5166",
  "content-icons-ui": "static-1.2410",
  "integrations-lib": "static-1.17169",
  "calling-global-api": "static-1.65786",
  "calling-internal-common": "static-1.31676",
  "calling-lifecycle-internal": "static-1.67168",
  "calling-lifecycle-messages": "static-1.59462",
  "commerce-products-lib": "static-1.10645",
  "crm-index-visualization-core": "static-1.4600",
  "crm-links": "static-1.6658",
  "customer-data-properties-shared-msw-handlers": "static-1.10032",
  "file-manager-components": "static-1.24610",
  "formula-editor": "static-1.14843",
  "google-libphonenumber": "static-1.46",
  "inbounddb-objects-service-types": "static-1.4460",
  "meetings-icalendar-utils-lib": "static-1.990",
  "object-builder-ui-client": "static-1.49792",
  "pipeline-validation-client-types": "static-1.4218",
  "property-value-citations": "static-1.3351",
  "smart-data-capture-core": "static-1.224",
  "smart-property-lib": "static-1.8406",
  "tiered-pricing": "static-1.2040",
  "topics-actions-lib": "static-1.525",
  "trial-components-library": "static-1.14191",
  "ui-addon-iframeable": "static-1.9432",
  "zustand": "static-1.86",
  "final-form": "static-1.79",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.79",
  "rich-text-lib": "static-1.20381",
  "tinymce-themes": "static-1.57165",
  "data-token-picker": "static-1.16958",
  "hub-http-contrib": "static-1.3387",
  "interframe": "static-3.5102",
  "tinymce-data": "static-1.41280",
  "tinymce-plugins": "static-1.58309",
  "ui-addon-sales-email": "static-1.5561",
  "framework-data-schema-quick-fetch": "static-1.7154",
  "ui-addon-opt": "static-4.8714",
  "hubspot-apollo-cache": "static-1.689",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.503",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.60",
  "purchase-motions-api": "static-1.6474",
  "onboarding-data-sync-lib": "static-1.2603",
  "growth-onboarding-next-action-components": "static-1.2809",
  "user-context-client": "static-1.4864",
  "idb-keyval": "static-1.52",
  "magpie-types": "static-1.5255",
  "nest": "static-1.591",
  "reactive-lib": "static-1.1073",
  "simple-logging-lib": "static-1.3405",
  "unified-auth-core-lib": "static-1.1291",
  "getting-started-shared-tasks-store": "static-1.18461",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1872",
  "integrations-error-boundary-lib": "static-1.14584",
  "integrations-tracking-lib": "static-1.5965",
  "native-integrations-shared-strings": "static-1.8125",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10726",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1009",
  "calling-error-reporting": "static-1.31683",
  "shared-worker-versioning": "static-1.11396",
  "calling-usage-tracker": "static-1.6891",
  "voice-sms-access-library": "static-1.2166",
  "customer-data-tracking": "static-1.7229",
  "commerce-permissions": "static-1.1132",
  "products-iframe-lib": "static-1.8677",
  "products-ui-components-shared-msw-handlers": "static-1.11087",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10788",
  "sales-views-client-types": "static-1.4611",
  "location-customization-utils-lib": "static-1.10201",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4500",
  "video-components-external": "static-1.12236",
  "video-data-lib": "static-1.35894",
  "bark-lib": "static-1.16872",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.103",
  "crm-properties-common-lib": "static-1.6244",
  "react-codemirror": "static-1.10998",
  "data-agent-kit": "static-1.722",
  "feedback-loader": "static-1.29882",
  "fsm": "static-1.4108",
  "policy-lib": "static-1.7161",
  "react-colorpicker": "static-2.10569",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10851",
  "embedded-academy-lib": "static-1.15681",
  "hubs-service-types": "static-1.1615",
  "salesImages": "static-1.616",
  "FileManagerLib": "static-1.40250",
  "NamespacedHubStyle": "static-2.9295",
  "FileManagerCore": "static-1.40109",
  "content-assistance-lib": "static-1.8268",
  "layout-dnd-components": "static-1.13042",
  "layout-dnd-utils": "static-1.12017",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-brand-identity-lib": "static-1.16661",
  "InboxConnectUtils": "static-4.15647",
  "meetings-connect-utils-lib": "static-1.7966",
  "breeze-engine-chat-components": "static-1.850",
  "breeze-engine-core": "static-1.1150",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "universal-page-editor-lib": "static-1.3364",
  "adobe-sign-auth-lib": "static-1.559",
  "ads-unified-auth-lib": "static-1.1550",
  "custom-vendor-connection-lib": "static-1.59",
  "google-sheets-integration-lib": "static-1.1122",
  "microsoft-drive-auth-lib": "static-1.257",
  "surveymonkey-integration-lib": "static-1.596",
  "slack-ui-library": "static-1.10753",
  "calling-orchestration-schema": "static-1.36943",
  "crm-record-cards-service-types": "static-1.3802",
  "content-media-composition-data-lib": "static-1.13350",
  "content-media-compositions": "static-2.17357",
  "media-bridge-lib": "static-1.19476",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16454",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4862",
  "nudge-client-utils": "static-1.3222",
  "storybook-react": "static-1.41",
  "academy-common-lib": "static-1.15141",
  "audio-components": "static-1.6415",
  "FileManagerImages": "static-1.37761",
  "video-components": "static-1.14238",
  "breeze-artifacts-sdk": "static-1.521",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4877",
  "video-embed": "static-1.36728",
  "ui-addon-video-player": "static-1.9050",
  "ui-coaching-tips": "static-1.29400",
  "ContentData": "static-1.69301",
  "layout-data-lib": "static-1.10342",
  "nudge-custom-function-registry": "static-1.2979",
  "nudge-renderer-utils": "static-1.3298",
  "whisper-core-api": "static-1.7420",
  "academy-service-client": "static-1.4046",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4753",
  "trellis-ecosystem": "static-1.7696",
  "ui-addon-react-router-dom": "static-1.9887",
  "wootric-nps": "static-1.7232",
  "social-insights-client-types": "static-1.22728",
  "outpost": "static-1.4499",
  "growth-onboarding-feedback-components": "static-1.6940",
  "advanced-menus-core": "static-1.15645",
  "advanced-menus-lib": "static-1.12506",
  "ExportDialog": "static-6.10734",
  "ui-memberships-settings-lib": "static-1.34934",
  "marketplace-ui-apps-core": "static-1.19366",
  "marketplace-ui-common": "static-1.20834",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15644",
  "simple-menus-lib": "static-1.17161",
  "settings-ui-lib": "static-1.12878",
  "developer-experience-shared-components": "static-1.10892",
  "immutable-less": "static-1.5005",
  "marketplace-ui-client-types": "static-1.18241",
  "ui-addon-integrations-directory-panel": "static-2.8375",
  "ui-extensibility-client-types": "static-1.4272",
  "ai-settings-ui-library": "static-1.8413",
  "nav-meta": "static-1.30562",
  "ui-product-approvals-common": "static-1.1223",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4588",
  "simple-data-table": "static-1.3605"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35321",
  "atom": "/atom/static-1.5436",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2839",
  "client-types": "/client-types/static-1.501",
  "cssUtils": "/cssUtils/static-1.978",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41062",
  "customer-data-objects": "/customer-data-objects/static-1.8048",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8446",
  "documents-lib": "/documents-lib/static-1.35326",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.375",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86660",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5074",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2549",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.112",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5945",
  "hs-test-utils": "/hs-test-utils/static-1.8391",
  "hub-http": "/hub-http/static-1.6567",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyle": "/HubStyle/static-2.12153",
  "HubStyleTokens": "/HubStyleTokens/static-2.11846",
  "I18n": "/I18n/static-7.1681",
  "icons": "/icons/static-2.695",
  "jasmine-immutable": "/jasmine-immutable/static-1.3367",
  "jasmine-runner": "/jasmine-runner/static-1.6804",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7507",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3246",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5740",
  "quartz": "/quartz/static-1.7520",
  "react": "/react/static-7.199",
  "react-dlb": "/react-dlb/static-1.90",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1.17079",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5592",
  "react-virtualized": "/react-virtualized/static-2.108",
  "reference-resolvers": "/reference-resolvers/static-1.8536",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8458",
  "reporting-data": "/reporting-data/static-1.68973",
  "reporting-reports": "/reporting-reports/static-1.68649",
  "reporting-snowflake": "/reporting-snowflake/static-1.57589",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10906",
  "reporting-visualizations": "/reporting-visualizations/static-1.61047",
  "reselect": "/reselect/static-3.13",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9299",
  "sanitize": "/sanitize/static-1.4826",
  "sanitize-text": "/sanitize-text/static-1.8512",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2089",
  "signup-constants": "/signup-constants/static-1.19709",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8414",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "superstore": "/superstore/static-1.5115",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5105",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11459",
  "ui-images": "/ui-images/static-2.1265",
  "UIComponents": "/UIComponents/static-3.8792",
  "usage-tracker": "/usage-tracker/static-1.7667",
  "usage-tracker-container": "/usage-tracker-container/static-1.7657",
  "usage-tracker-core": "/usage-tracker-core/static-1.7517",
  "viral-links-lib": "/viral-links-lib/static-1.7430",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10005",
  "foundations-components": "/foundations-components/static-1.8569",
  "immutable": "/immutable/static-2.87",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1298",
  "quartz-core": "/quartz-core/static-1.6739",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.80",
  "redux-thunk": "/redux-thunk/static-2.81",
  "rpc-client-utils": "/rpc-client-utils/static-1.5020",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11502",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18447",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3797",
  "quartz-webpack": "/quartz-webpack/static-1.3744",
  "foundations-assets": "/foundations-assets/static-1.5241",
  "foundations-theming": "/foundations-theming/static-1.4833",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10705",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "sassPrefix": "/sassPrefix/static-1.244",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
  "crm-message-bus": "/crm-message-bus/static-1.43867",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23497",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13386",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13527",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10186",
  "events-data-lib": "/events-data-lib/static-1.603",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4257",
  "hs-resources": "/hs-resources/static-1.548",
  "immer": "/immer/static-1.102",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4082",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1361",
  "onboarding-scopes": "/onboarding-scopes/static-1.6807",
  "onboarding-tours": "/onboarding-tours/static-1.17209",
  "pulse": "/pulse/static-1.986",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14555",
  "segments-client-types": "/segments-client-types/static-1.11710",
  "stylex": "/stylex/static-1.42",
  "trellis-assets": "/trellis-assets/static-1.2771",
  "trellis-components": "/trellis-components/static-1.2790",
  "trellis-theming": "/trellis-theming/static-1.1329",
  "ui-addon-teams": "/ui-addon-teams/static-1.21960",
  "quartz-auth": "/quartz-auth/static-1.1195",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9446",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5353",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9818",
  "ContentUtils": "/ContentUtils/static-1.69226",
  "customer-data-properties": "/customer-data-properties/static-1.52737",
  "forms-ai-lib": "/forms-ai-lib/static-1.4829",
  "forms-utils-lib": "/forms-utils-lib/static-1.13160",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6052",
  "react-dnd-compat": "/react-dnd-compat/static-1.4970",
  "react-tinymce": "/react-tinymce/static-1.56069",
  "tinymce-config": "/tinymce-config/static-2.55195",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10644",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3818",
  "HeadJS": "/HeadJS/static-2.805",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3502",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "hs-locale-management": "/hs-locale-management/static-1.330",
  "ui-fonts": "/ui-fonts/static-1.1108",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4667",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1185",
  "web-vitals": "/web-vitals/static-1.16",
  "batch-promise": "/batch-promise/static-1.1899",
  "external-options-client-types": "/external-options-client-types/static-1.4375",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7249",
  "quartz-i18n": "/quartz-i18n/static-1.1195",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8275",
  "graphql": "/graphql/static-1.90",
  "persist-promise": "/persist-promise/static-1.4056",
  "reporting-client-types": "/reporting-client-types/static-1.2724",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
  "growth-payments-core": "/growth-payments-core/static-1.26282",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5230",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1594",
  "quartz-routing": "/quartz-routing/static-1.950",
  "hs-story-utils": "/hs-story-utils/static-1.9779",
  "react-flip-move": "/react-flip-move/static-1.79",
  "nested-table": "/nested-table/static-1.590",
  "seat-types-lib": "/seat-types-lib/static-1.808",
  "timezone-utils": "/timezone-utils/static-2.5590",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4838",
  "floating-ui": "/floating-ui/static-1.64",
  "react-aria": "/react-aria/static-1.73",
  "tanstack-table": "/tanstack-table/static-1.62",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.134",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.509",
  "quartz-test": "/quartz-test/static-1.1195",
  "quartz-tracking": "/quartz-tracking/static-1.899",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.430",
  "chirp-fetch": "/chirp-fetch/static-1.2252",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6471",
  "ts-schema": "/ts-schema/static-1.4328",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3316",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1769",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5005",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4052",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4383",
  "event-emitter": "/event-emitter/static-1.1312",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.368",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3943",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19343",
  "growth-data-modal": "/growth-data-modal/static-1.5965",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3420",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2781",
  "navigation-components": "/navigation-components/static-1.18925",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5424",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1276",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10626",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8007",
  "ui-universal-auth": "/ui-universal-auth/static-1.9495",
  "user-context": "/user-context/static-1.5469",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.489",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6800",
  "stylex-utils": "/stylex-utils/static-1.149",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10703",
  "magpie-lib": "/magpie-lib/static-1.5795",
  "navigation-messaging": "/navigation-messaging/static-1.8252",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23268",
  "copilot-toolkit": "/copilot-toolkit/static-1.11935",
  "cms-field-types": "/cms-field-types/static-1.5166",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "integrations-lib": "/integrations-lib/static-1.17169",
  "calling-global-api": "/calling-global-api/static-1.65786",
  "calling-internal-common": "/calling-internal-common/static-1.31676",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67168",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59462",
  "commerce-products-lib": "/commerce-products-lib/static-1.10645",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4600",
  "crm-links": "/crm-links/static-1.6658",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10032",
  "file-manager-components": "/file-manager-components/static-1.24610",
  "formula-editor": "/formula-editor/static-1.14843",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4460",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.990",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49792",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4218",
  "property-value-citations": "/property-value-citations/static-1.3351",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.224",
  "smart-property-lib": "/smart-property-lib/static-1.8406",
  "tiered-pricing": "/tiered-pricing/static-1.2040",
  "topics-actions-lib": "/topics-actions-lib/static-1.525",
  "trial-components-library": "/trial-components-library/static-1.14191",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9432",
  "zustand": "/zustand/static-1.86",
  "final-form": "/final-form/static-1.79",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "rich-text-lib": "/rich-text-lib/static-1.20381",
  "tinymce-themes": "/tinymce-themes/static-1.57165",
  "data-token-picker": "/data-token-picker/static-1.16958",
  "hub-http-contrib": "/hub-http-contrib/static-1.3387",
  "interframe": "/interframe/static-3.5102",
  "tinymce-data": "/tinymce-data/static-1.41280",
  "tinymce-plugins": "/tinymce-plugins/static-1.58309",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5561",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7154",
  "ui-addon-opt": "/ui-addon-opt/static-4.8714",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.689",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.503",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.60",
  "purchase-motions-api": "/purchase-motions-api/static-1.6474",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2603",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2809",
  "user-context-client": "/user-context-client/static-1.4864",
  "idb-keyval": "/idb-keyval/static-1.52",
  "magpie-types": "/magpie-types/static-1.5255",
  "nest": "/nest/static-1.591",
  "reactive-lib": "/reactive-lib/static-1.1073",
  "simple-logging-lib": "/simple-logging-lib/static-1.3405",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1291",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18461",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1872",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14584",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5965",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8125",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10726",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1009",
  "calling-error-reporting": "/calling-error-reporting/static-1.31683",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11396",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6891",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2166",
  "customer-data-tracking": "/customer-data-tracking/static-1.7229",
  "commerce-permissions": "/commerce-permissions/static-1.1132",
  "products-iframe-lib": "/products-iframe-lib/static-1.8677",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11087",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10788",
  "sales-views-client-types": "/sales-views-client-types/static-1.4611",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10201",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4500",
  "video-components-external": "/video-components-external/static-1.12236",
  "video-data-lib": "/video-data-lib/static-1.35894",
  "bark-lib": "/bark-lib/static-1.16872",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.103",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6244",
  "react-codemirror": "/react-codemirror/static-1.10998",
  "data-agent-kit": "/data-agent-kit/static-1.722",
  "feedback-loader": "/feedback-loader/static-1.29882",
  "fsm": "/fsm/static-1.4108",
  "policy-lib": "/policy-lib/static-1.7161",
  "react-colorpicker": "/react-colorpicker/static-2.10569",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10851",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15681",
  "hubs-service-types": "/hubs-service-types/static-1.1615",
  "salesImages": "/salesImages/static-1.616",
  "FileManagerLib": "/FileManagerLib/static-1.40250",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "FileManagerCore": "/FileManagerCore/static-1.40109",
  "content-assistance-lib": "/content-assistance-lib/static-1.8268",
  "layout-dnd-components": "/layout-dnd-components/static-1.13042",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12017",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16661",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15647",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7966",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.850",
  "breeze-engine-core": "/breeze-engine-core/static-1.1150",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3364",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.559",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1550",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.59",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1122",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.257",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.596",
  "slack-ui-library": "/slack-ui-library/static-1.10753",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36943",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3802",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13350",
  "content-media-compositions": "/content-media-compositions/static-2.17357",
  "media-bridge-lib": "/media-bridge-lib/static-1.19476",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16454",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4862",
  "nudge-client-utils": "/nudge-client-utils/static-1.3222",
  "storybook-react": "/storybook-react/static-1.41",
  "academy-common-lib": "/academy-common-lib/static-1.15141",
  "audio-components": "/audio-components/static-1.6415",
  "FileManagerImages": "/FileManagerImages/static-1.37761",
  "video-components": "/video-components/static-1.14238",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.521",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4877",
  "video-embed": "/video-embed/static-1.36728",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9050",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29400",
  "ContentData": "/ContentData/static-1.69301",
  "layout-data-lib": "/layout-data-lib/static-1.10342",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2979",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3298",
  "whisper-core-api": "/whisper-core-api/static-1.7420",
  "academy-service-client": "/academy-service-client/static-1.4046",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4753",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7696",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9887",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "social-insights-client-types": "/social-insights-client-types/static-1.22728",
  "outpost": "/outpost/static-1.4499",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6940",
  "advanced-menus-core": "/advanced-menus-core/static-1.15645",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12506",
  "ExportDialog": "/ExportDialog/static-6.10734",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34934",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19366",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20834",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15644",
  "simple-menus-lib": "/simple-menus-lib/static-1.17161",
  "settings-ui-lib": "/settings-ui-lib/static-1.12878",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10892",
  "immutable-less": "/immutable-less/static-1.5005",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18241",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8375",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4272",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8413",
  "nav-meta": "/nav-meta/static-1.30562",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1223",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4588",
  "simple-data-table": "/simple-data-table/static-1.3605"
}
};
